export default {"src":"/_next/static/media/0x87edffde3e14c7a66c9b9724747a1c5696b742e6.cdb0c9a1.svg","height":126,"width":126,"blurWidth":0,"blurHeight":0};